import { USER_ROLES, WEBBACK_V2_API } from "@constants"
import { useUserApp } from "@hooks"

const V2_STOCK = `${WEBBACK_V2_API}/stock-assortment`
const V2_PRICING = `${WEBBACK_V2_API}/pricing`

// **The url no longer depends on the role** — same reasoning as Stock/Changes: v1 has a twin nested
// per role (`share-retailer`, `share-seller`), v2 has one endpoint and resolves the reference price
// from the role in the back. See dipi-webback-v2/plans/869e5pfw2--rrsp-and-retailers.md §5.1 · §0.6.
//
// The SkuDetailsTable drill-down (`table-pricing-new`) was already role-agnostic in v1 and stays
// that way. ⚠️ It answers the **RRSP** to everyone on purpose, retailers included: the column is
// labelled the literal 'RRSP' with no role branch in the front, so returning a site's price there
// would mislabel it (§0.3). It is the one reference-price consumer deliberately left out of the
// resolver, and it moves the day that table gets a retailer variant.
//
// The role is still returned: the table and the Excel relabel the price column by it.

export default function useStockShareRoleConfig() {
	const { userRole, userUseRRSP } = useUserApp()

	return {
		urlApi: `${V2_STOCK}/share/context`,
		urlApiExcel: `${V2_STOCK}/share/excel`,
		urlApiSkuDetails: `${V2_PRICING}/price-evolution/table-pricing-new`,
		isMarketplacesUser: userRole === USER_ROLES.MARKETPLACES,
		isRetailerUser: userRole === USER_ROLES.RETAILER,
		userUseRRSP: userUseRRSP
	}
}
